import * as angular from 'angular';
import * as _ from 'underscore';

class PasswordConfirmationController {
    static $inject = ['jispPayService', 'notificationService', '$translate'];

    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;

    password: string;
    waiting: boolean;

    constructor(
        private $translate: angular.translate.ITranslateService
    ) {
    }

    isValidModel() {
        this.password = this.password ? this.password.trim() : '';
        return this.password.length > 0;
    }


    confirm = async () => {
        if (!this.isValidModel()) {
            return;
        }

        this.waiting = true;
        this.modalInstance.close({ $value: this.password });

    }

    cancel = () => {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }
}

angular.module('naut').component('passwordConfirmation', {
    template: require('./passwordConfirmation.html'),
    controller: PasswordConfirmationController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/passwordConfirmation/passwordConfirmation.component.ts